<template>
    <div class="custom-tree-node" :class="{'is-disabled': disabled}">
        <div class="tree-node-label"  :title="currentValue">{{ currentValue }}</div>
        <div class="tree-node-action-sheet">
            <div class="tree-node-action-sheet-item" v-for="action in actionSheet"
              :key="action.command">
                <template v-if="itemNeedShow(action)">
                  <template v-if="action && action.placement !== 'top' && action.confirm">
                      <h-pop-confirm :content="action.confirm.text" @confirm="onNodeClick(action)">
                          <common-icon  :type="nodeIsActive(action) ? action.activeIcon : action.icon" :size="14" :title="nodeIsActive(action) ? action.actionName : action.name"></common-icon>
                      </h-pop-confirm>
                  </template>
                  <template v-else-if="action && action.placement !== 'top'">
                      <common-icon  @click.native.stop="onNodeClick(action)" :type="nodeIsActive(action) ? action.activeIcon : action.icon" :size="14" :title="nodeIsActive(action) ? action.activeName : action.name"></common-icon>
                  </template>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    node: Object,
    data: Object,
    value: {},
    options: Object,
    disabled: Boolean,
    actionSheet: {
      type: Array,
      default () {
        return []
      }
    }
  },
  watch: {
    value () {
      this.currentValue = this.value
    }
  },
  data () {
    return {
      currentValue: '',
      edit: false
    }
  },
  methods: {
    onNodeClick (action) {
      this.$emit('command', action.command, {node: this.node, data: this.data})
    },
    nodeIsActive (item) {
      return Boolean(this.data && this.data[item.activeProp])
    },
    itemNeedShow (item) {
      if (item.show && typeof item.show === 'function') {
        return item.show(this.data)
      }
      if (typeof item.show === 'undefined' || item.show === null) return true
      return !!item.show
    }
  },
  mounted () {
    this.currentValue = this.value
  }
}
</script>

<style lang="less">
@import '../../color.less';
.custom-tree-node {
    font-size: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 276px;
    padding-right: 10px;
    .tree-node-action-sheet {
        visibility: hidden;
        opacity: 0;
        display: flex;
        justify-content: flex-end;
        flex: 1;
        transition: opacity .3s;
        &-item {
            &:hover {
                color: @primary;
            }
        }
        .tree-node-action-sheet-item + .tree-node-action-sheet-item {
            margin-left: 10px;
        }
    }
    &:hover {
        .tree-node-action-sheet {
            visibility: visible;
            opacity: 1;
        }
    }
}
.tree-node-label {
    font-size: 14px;
    flex: 0 0 160px;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.tree-node-status {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    vertical-align: middle;
    margin-right: 10px;
    background: #e3e4e5;
    &.active {
        background: #409eff;
    }
    & + .tree-node-label {
        vertical-align: middle;
    }
}
.custom-tree-node.is-disabled {
    .tree-node-label {
        color: rgb(153, 153, 153)
    }
}
</style>



// WEBPACK FOOTER //
// src/components/tree/tree-node.vue